import {useLocation} from "react-router-dom";
import {Material_Type} from "@generated/graphql";
import ROUTE from "constants/route";

const useMaterialType = () => {
  const location = useLocation();
  return location.pathname.includes(ROUTE.MATERIAL) ? Material_Type.Material : Material_Type.KnowledgeBase
}
export default useMaterialType;
